import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from './ThemeContext/ThemeContext';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';

/**
 * Root application component that provides theme context and error boundary
 * Wraps all pages to ensure consistent theming and error handling
 */
function App({ children }) {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        {children}
      </ThemeProvider>
    </ErrorBoundary>
  );
}

App.propTypes = {
  children: PropTypes.node.isRequired,
}

export default App;
